import NextIcon from 'assets/icons/controls/NextIcon';
import { IconSize } from 'assets/icons/icon-sizes';
import { ExternalSecondaryLinkButton, FlexMdAlignCenter } from 'components/Elements';
import styled from 'styled-components';
import { theme, sizes, breakpoints, FONTSIZE } from 'theme';
import strings from '../../../strings/strings.json';

type BottomButtonSectionProps = {
    joinCourseButton: JSX.Element;
};

export default function BottomButtonSection({ joinCourseButton }: BottomButtonSectionProps) {
    return (
        <PageBottomButtonContainer>
            {joinCourseButton}
            <StyledLinkButton
                aria-label={strings.publicCoursePage.neveInfoSection.neveLearningLinkAria}
                href="https://www.nevelearning.co.uk/"
                target="_blank"
            >
                {strings.publicCoursePage.neveInfoSection.neveLearningLink}
                <NextIcon size={IconSize.LARGE} colour={`${theme.footerBackground}`} />
            </StyledLinkButton>
        </PageBottomButtonContainer>
    );
}

const PageBottomButtonContainer = styled(FlexMdAlignCenter)`
    padding: ${sizes.spacingLg} 0;
    justify-content: space-between;

    @media (max-width: ${breakpoints.md}) {
        flex-direction: column;
        gap: ${sizes.spacingLg};
        align-items: flex-start;
    }
`;

const StyledLinkButton = styled(ExternalSecondaryLinkButton)`
    display: flex;
    align-items: center;
    gap: ${sizes.spacingSm};
    color: ${theme.footerBackground};
    font-size: ${FONTSIZE.BodyLarge};

    @media (max-width: ${breakpoints.sm}) {
        gap: unset;
    }
`;
